<template>
  <el-dialog
    :title="model.id ? '编辑公告' : '新增公告'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="70%"
    @close="$emit('update:show', false)"
    @open="opened()"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="90px"
      size="small"
    >
      <el-form-item label="标题" prop="title">
        <el-input v-model="model.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="分类" prop="notice_category_id">
        <category-select
          @change="model.notice_category_id = $event"
          :val="model.notice_category_id"
        ></category-select>
      </el-form-item>
      <el-form-item label="摘要" prop="summary">
        <el-input
          type="textarea"
          v-model="model.summary"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="content" class="ql-editor-item">
        <rich-editor class="editor" v-model="model.content"></rich-editor>
      </el-form-item>
      <el-form-item label="附件" prop="files">
        <el-upload
          class="avatar-uploader"
          :action="fileUploadUrl"
          :limit="10"
          accept=".doc, .docx, .xls, .xlsx,.pdf"
          :headers="uploadHeader"
          :file-list="fileList"
          :on-remove="handleFileRemove"
          :on-success="handleFileSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeUpload"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            最多10个文件，支持格式：.doc(x),.xls(x),.pdf，单个文件不超过10M
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="submitForm" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { createNotice, updateNotice } from '@/service/getData'
import RichEditor from '@/components/rich-editor'
import { urlPerfix } from '../../../config/env'
import store from '../../../store/store'
import CategorySelect from '@/components/select/notice_category_select'

export default {
  components: { RichEditor, CategorySelect },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      fileUploadUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      fileList: [],
      rules: {
        title: [
          { required: true, message: '请填写标题', trigger: 'blur' },
          {
            min: 2,
            max: 150,
            message: '长度在 2 到 150 个字符',
            trigger: 'blur',
          },
        ],
        notice_category_id: [
          { required: true, message: '请选择分类', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    opened() {
      this.fileList = this.model.files || []
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await updateNotice(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createNotice(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }

          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeUpload(file) {
      const isLimitSize = file.size / 1024 / 1024 < this.uploadLimitSize.file
      if (!isLimitSize) {
        this.$message.error(`文件大小不能超过 ${this.uploadLimitSize.file}MB!`)
      }
      return isLimitSize
    },
    handleFileRemove(index) {
      this.model.files.splice(index, 1)
    },
    handleFileSuccess(res, file) {
      if (res.code == 0) {
        this.model.files.push({
          name: file.name,
          size: file.size,
          url: res.data,
        })
      }
    },
  },
}
</script>
<style>
.ql-editor-item .el-form-item__content {
  line-height: 24px;
}
</style>

<style scoped>
/deep/.ql-editor {
  min-height: 100px;
}
/deep/.ql-container.ql-snow,
/deep/.ql-toolbar.ql-snow {
  border-color: #ddd;
}
</style>